var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3332 20.0001C38.3332 9.87486 30.1251 1.66675 19.9998 1.66675C9.87462 1.66675 1.6665 9.87486 1.6665 20.0001C1.6665 30.1253 9.87462 38.3334 19.9998 38.3334C30.1251 38.3334 38.3332 30.1253 38.3332 20.0001Z",
    fill: "url(#paint0_linear_432:838)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 2.16675C29.8489 2.16675 37.8332 10.151 37.8332 20.0001C37.8332 29.8492 29.8489 37.8334 19.9998 37.8334C10.1508 37.8334 2.1665 29.8492 2.1665 20.0001C2.1665 10.151 10.1508 2.16675 19.9998 2.16675Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8217 16.1784L17.3572 19.714L13.8217 23.2495C13.1708 23.9004 13.1708 24.9556 13.8217 25.6065C14.4725 26.2574 15.5278 26.2574 16.1787 25.6065L19.7142 22.071L23.2497 25.6065C23.9006 26.2574 24.9559 26.2574 25.6068 25.6065C26.2576 24.9556 26.2576 23.9004 25.6068 23.2495L22.0712 19.714L25.6068 16.1784C26.2576 15.5276 26.2576 14.4723 25.6068 13.8214C24.9559 13.1705 23.9006 13.1705 23.2497 13.8214L19.7142 17.3569L16.1787 13.8214C15.5278 13.1705 14.4725 13.1705 13.8217 13.8214C13.1708 14.4723 13.1708 15.5276 13.8217 16.1784Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_432:838",
    x: -10.3335,
    y: -10.3333,
    width: 60.6665,
    height: 60.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_432:838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_432:838",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_432:838",
    x1: 19.9998,
    y1: 1.66675,
    x2: 19.9998,
    y2: 38.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5A5A",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC5A5A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.099ab6dd.svg";
export { ForwardRef as ReactComponent };